import { Component, inject, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-date-range-picker',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
})
export class DateRangePickerComponent implements OnInit {
  @SkipSelf() private controlContainer = inject(ControlContainer);

  @Input({ required: true }) controlKey = '';
  @Input() label: string;

  public formGroup: FormGroup;

  ngOnInit() {
    const formGroup: FormGroup | null = this.controlContainer?.control?.get(
      this.controlKey,
    ) as FormGroup;
    if (!formGroup) {
      console.error(`There is no formGroup with name "${this.controlKey}" in parent formGroup`);
    }
    this.formGroup = formGroup;
  }
}
